export default "__VITE_ASSET__DYq6oYsy__"